import React, { useState } from 'react'
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { Box, Divider, Modal, Typography } from '@mui/material/'
import style  from '../../../styles/mystyle.module.css'
import * as config  from '../../../next.config.js'
const SearchOffer = (props) => {
    const [open, setOpen] = useState(false)
    const { t } = useTranslation("common");
    const handleClose = () => setOpen(false)
    const [productName, setproductName] = useState("");  
    const handleChangeName = name => {    
        setproductName(name.currentTarget.value);
      };
    return (
        <Box className={style.searchboxcontainer+ " "+ style.paddingSearch} sx={{
            maxWidth: {
                xs: 300,
                sm: 500
            }
        }}>
            <form
              onSubmit={(e)=> {
                e.preventDefault();
                props.searchOfferName(productName)
           }} 
            className= {style.searchbox}>
              
                <Modal
                    open={open}
                    onClose={handleClose}
                >
                    <Box sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%,-50%)',
                        width: 400,
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4
                    }}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            {t('ModalTitle')}
                            </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            </Typography>
                    </Box>
                </Modal>
                <Divider sx={{ height: 'auto', m: 0.5 }} orientation="vertical" />
                <input  className={style.search}  type="text" placeholder={t("placeholder")}
                
                value={productName}
                onChange={name => handleChangeName(name)}
                />
                <button  className={style.btnsearch}>
                <img  className={style.imgsearch}src={`${config.basePath}/assest/search-pink.svg`}/>
                </button>
            </form>
        </Box>
    )
}

export default SearchOffer
